const UserRoles = {
  CUSTOMER: 'customer',
  ACCOUNT_AGENT: 'accountAgent',
  AGENT_USER: 'agentUser',
}

export default UserRoles
